import { SpaIcon } from './SpaIcon';

/**
 * author: Google
 * id 84F00C86-0380-4554-B142-286C3B80BA3A
 * name spa
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spa.svg
 * tags
 * - Nature 
 */
export const FlowerLotusIcon = SpaIcon;
export default FlowerLotusIcon